import { render, staticRenderFns } from "./color-official-colors.vue?vue&type=template&id=6933827a&scoped=true"
import script from "./color-official-colors.vue?vue&type=script&lang=js"
export * from "./color-official-colors.vue?vue&type=script&lang=js"
import style0 from "./color-official-colors.vue?vue&type=style&index=0&id=6933827a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6933827a",
  null
  
)

export default component.exports